import React from 'react';

export default function CardView({ title, blurb, badge, badgeDetail }) {
    return (
        <div className="max-w-sm bg-white rounded-2xl hover:shadow-lg border border-gray-200 overflow-hidden mx-2 flex flex-col">
            {/* Card content */}
            <div className="py-4 px-4 flex flex-col flex-1">
                {/* Title */}
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {title}
                </h3>

                {/* Description */}
                <div className="text-gray-600 text-base leading-relaxed mb-4 flex-1">
                    {blurb}
                </div>

                {/* Badge section */}
                {badge && (
                    <div className="bg-gray-50 border border-gray-100 p-4 rounded-xl mt-auto">
                        <div className="flex items-center gap-2 mb-1">
                            <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-2.5 py-1 rounded-full">
                                {badge}
                            </span>
                        </div>
                        {badgeDetail && (
                            <p className="text-sm text-gray-500 mt-1">{badgeDetail}</p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
